import uploadFile from './upload-file';

export default function dropInsideFolder(actualParams: string, quoteId: number, dispatch, onUpload) {
  return (name) => {
    const separator = actualParams ? '/' : '?directory=';
    const params = `${actualParams}${separator}${name}`;
    return uploadFile(params, quoteId, dispatch, onUpload);
  };
}
